(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputCheckbox', cpInputCheckbox);

    cpInputCheckbox.$inject = [];

    function cpInputCheckbox() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-checkbox/input-checkbox.html',
            scope: {
                title: '@',
                containerClass: '@',
                object: '=',
                prop: '@',
                isRequired: '=?',
                isDisabled: '=?',
                onChange: '&?',
                onEdit: '&?'
            },
            link: function(scope, element, attrs, controller) {
                scope.getContainerClass = getContainerClass;
                scope.isWithLabel = isWithLabel;

                function isWithLabel() {
                    return scope.withLabel === undefined ? true : scope.withLabel;
                }

                function getContainerClass() {
                    if (scope.containerClass) {
                        return scope.containerClass;
                    } else {
                        return isWithLabel() ? 'col-sm-offset-2 col-sm-10' : 'col-sm-12';
                    }
                }
            }
        };
    }
})();
